import { apiFetch } from '@/lib/api/http';

/** 優秀者選定・態度フィードバック（指示書 §10・§12 M9 / DECISIONS D-034）. */
export type AttitudeFlag = 'good' | 'bad';

export const ATTITUDE_LABELS: Record<AttitudeFlag, string> = {
  good: 'Good',
  bad: 'Bad',
};

export interface SubcommitteeFeedback {
  id: string;
  event_id: string;
  member_id: string;
  member_name: string | null;
  is_best_performer: boolean;
  attitude: AttitudeFlag | null;
}

export function fetchSubcommitteeFeedback(eventId: string): Promise<SubcommitteeFeedback[]> {
  return apiFetch<SubcommitteeFeedback[]>(`/events/${eventId}/subcommittee-feedback`);
}

export function submitSubcommitteeFeedback(
  eventId: string,
  payload: { member_id: string; is_best_performer: boolean; attitude?: AttitudeFlag | null },
): Promise<SubcommitteeFeedback> {
  return apiFetch<SubcommitteeFeedback>(`/events/${eventId}/subcommittee-feedback`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

/** 入力できる会員（担当会員かつこのイベントの対象者 / システムテストで発見・D-047）. */
export interface EligibleMember {
  id: string;
  member_id: string;
  name: string;
}

export function fetchEligibleMembers(eventId: string): Promise<EligibleMember[]> {
  return apiFetch<EligibleMember[]>(`/events/${eventId}/subcommittee-feedback/eligible-members`);
}
